/**
 * Used to determine how some keyboard input is handled.
 *
 * If this gets more complex, we should look at modularizing some of
 * the keyboard input handling further. E.g. hooks for specific roles instead of interweaving them inside of `useStandardMenuKeyboardSupport` and friends
 */ export var StandardMenuType;
(function(StandardMenuType) {
    /** Indicates the standard menu is embedded in something else (e.g. a popover) */ StandardMenuType["EMBEDDED"] = "embedded";
    /** Indicates the standard menu is the sole focus of a dropdown menu */ StandardMenuType["DROPDOWN"] = "dropdown";
})(StandardMenuType || (StandardMenuType = {}));
